import React from 'react';
import { Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { useTranslation } from 'hooks/useTranslation';
import * as _ from 'lodash';

export const PrivacyPolicyPage = () => {
  const classes = useStyles();
  const { t } = useTranslation('privacy-policy');

  const sectionKeys: Array<
    | 'section1'
    | 'section2'
    | 'section3'
    | 'section4'
    | 'section5'
    | 'section6'
    | 'section7'
    | 'section8'
    | 'section9'
    | 'section10'
  > = [
    'section1',
    'section2',
    'section3',
    'section4',
    'section5',
    'section6',
    'section7',
    'section8',
    'section9',
    'section10',
  ];

  return (
    <>
      <div>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>{t('title')}</Typography>
          <Typography className={classes.headerSubtitle}>{t('subTitle')}</Typography>
        </div>
        <div className={classes.container}>
          <div className="my-3 md-order-2 col-lg-8">
            <Typography className={classes.boldFont}>{t('introduction.welcome')}</Typography>
            <Typography>{t('introduction.companyLocation')}</Typography>
            <Typography className={classes.boldFont}>{t('introduction.attention')}</Typography>
            {(t('introduction.paragraphs', { returnObjects: true }) as unknown as Array<string>).map((text, index) => (
              <Typography key={index}>{text}</Typography>
            ))}
            {sectionKeys.map(sectionKey => (
              <div className={classes.termsTopic} id={sectionKey} key={sectionKey}>
                <Typography className={classes.title}>{t(`${sectionKey}.title`)}</Typography>
                {(t(`${sectionKey}.paragraphs`, { returnObjects: true }) as unknown as Array<string>).map(
                  (text, index) => (
                    <Typography key={index}>{text}</Typography>
                  )
                )}
                {_.isArray(t(`${sectionKey}.list`, { returnObjects: true })) && (
                  <ul>
                    {(t(`${sectionKey}.list`, { returnObjects: true }) as unknown as Array<string>).map(
                      (text, index) => (
                        <li key={index}>{<Typography>{text}</Typography>}</li>
                      )
                    )}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
